import { render, staticRenderFns } from "./VueSmartSliderPips.vue?vue&type=template&id=7628d018&scoped=true&"
import script from "./VueSmartSliderPips.vue?vue&type=script&lang=ts&"
export * from "./VueSmartSliderPips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7628d018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7628d018')) {
      api.createRecord('7628d018', component.options)
    } else {
      api.reload('7628d018', component.options)
    }
    module.hot.accept("./VueSmartSliderPips.vue?vue&type=template&id=7628d018&scoped=true&", function () {
      api.rerender('7628d018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/ui/slider/VueSmartSliderPips.vue"
export default component.exports